import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import * as Feather from "react-feather";
import { useSelector } from "react-redux";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { amountInWords } from "../components/common/functions";
import Card from "../components/custom/Card";
import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import { apiUrl } from "../config";
import { LocalFormatDate, rupeeFormat } from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { StoreState } from "../redux/reducers";
import "../styles/StudentFees.css";
import {
  StudentFeesDetails,
  StudentFeesPayment,
  StudentFeesType,
} from "./Interface";
import StudentAdmissionDropdown from "../components/custom/components/StudentAdmissionDropdown";
import { AccountHolderType } from "../redux/actions/accountHolder";

interface FeesAmounts {
  [key: string]: number;
}

interface StudentRegNo {
  id: number;
  registerNumber: string;
}

export interface StudentAdmissionNo {
  id: number;
  admissionNumber: string;
}
interface Option {
  value: string;
  label: string;
}

const StudentFeesByRegisterNo = () => {
  // const [studentRegNo, setStudentRegNo] = useState<StudentRegNo[]>([]);
  const [studentAdmissionNo, setStudentAdmissionNo] = useState<
    StudentAdmissionNo[]
  >([]);
  const [studentFeesList, setStudentFeesList] = useState<StudentFeesType[]>([]);
  const [studentMiscFeesList, setStudentMiscFeesList] = useState<
    StudentFeesType[]
  >([]);
  const [studentFeesDetails, setStudentFeesDetails] = useState<
    StudentFeesDetails[]
  >([]);
  const authUser = useSelector<StoreState, AuthUserType>(
    (state) => state.authUser,
  );
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  // const [registerNo, setRegisterNo] = useState<string>('');
  const [admissionNo, setAdmissionNo] = useState<string>("");

  const [title, setTitle] = useState("");
  const [academicPeriod, setAcademicPeriod] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ids, setId] = useState<number>(0);
  const [billNo, setBillNo] = useState<number>(0);
  const [feesType, setFeesType] = useState<string>("year");
  const [academicYear, setAcademicYear] = useState<string>("");
  const [amount, setAmount] = useState<string>("");
  const [date, setDate] = useState<string>(() => {
  const today = new Date();
  return today.toISOString().split("T")[0]; 
});
  const [particulars, setParticulars] = useState<string>("");
  const [amountError, setAmountError] = useState<string>("");
  const [paymentMode, setPaymentMode] = useState<"cash" | "bank">("cash");
  const [feesAmounts, setFeesAmounts] = useState<FeesAmounts>({});
  const [bankAccounts, setBankAccounts] = useState<AccountHolderType[]>([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState("");

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  //for bill
  const [selectedBill, setSelectedBill] = useState<{
    billNo: number;
    studentId: number;
  } | null>(null);
  const [showBillModal, setShowBillModal] = useState(false);
  const [billDetails, setBillDetails] = useState<StudentFeesPayment[]>([]);

  // const fetchStuRegNo = () => {
  //     axios.get<{ data: StudentRegNo[] }>(`${apiUrl}/student/getAllStuRegisterNo/`)
  //         .then((response) => {
  //             setStudentRegNo(response.data.data);
  //         })
  //         .catch((error) => console.log(error));
  // }

  useEffect(() => {
    axios
      .get(`${apiUrl}/accountHolder/`)
      .then((response) => {
        console.log(" RAW RESPONSE:", response);
        setBankAccounts(response.data.data || response.data || []);
      })
      .catch((error) => {
        console.error(" ERROR DETAILS:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data,
        });
      });
  }, []);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined = undefined;

    if (loading && progress < 90) {
      interval = setInterval(() => {
        setProgress((prev) => {
          const next = prev + 10;
          if (next >= 90) {
            if (interval) {
              clearInterval(interval);
            }
            return 90;
          }
          return next;
        });
      }, 400);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [loading]);
  const fetchStuAdmNo = () => {
    axios
      .get<{ data: StudentAdmissionNo[] }>(
        `${apiUrl}/student/getAllStuAdmissionNo/`,
      )
      .then((response) => {
        setStudentAdmissionNo(response.data.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchStuAdmNo();
  }, []);

  console.log(studentFeesList);
  console.log(studentMiscFeesList);

  const fetchStudentFeesList = (admissionNo: string) => {
    setStudentFeesList([]);
    axios
      .get<{ data: StudentFeesType[] }>(
        `${apiUrl}/student/studentFees/?admissionNumber=${admissionNo}`,
      )
      .then((response) => {
        setStudentFeesList(response.data.data);
      })
      .catch((error) => console.log(error));
  };

  const fetchStuMiscFeesList = (admissionNo: string) => {
    setStudentMiscFeesList([]);
    axios
      .get<{ data: StudentFeesType[] }>(
        `${apiUrl}/studentMiscFees/stuPaymentByRegNo/?admissionNumber=${admissionNo}`,
      )
      .then((response) => {
        setStudentMiscFeesList(response.data.data);
      })
      .catch((error) => console.log(error));
  };

  const fetchFeesDetails = async (admissionNumber: string) => {
    if (admissionNumber) {
      setStudentFeesDetails([]);
      try {
        const response = await axios.get<{ data: StudentFeesDetails[] }>(
          `${apiUrl}/studentFee/stuPaymentByRegNo/?admissionNumber=${admissionNumber}`,
        );
        const data = response.data.data;
        setStudentFeesDetails(data);
        setTitle(title);
        setAcademicPeriod(academicPeriod);
        setFeesType(feesType);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleBillClick = async (billNo: number, studentId: number) => {
    try {
      setSelectedBill({ billNo, studentId });
      const response = await axios.get<{ data: StudentFeesPayment[] }>(
        `${apiUrl}/studentFee/paymentPDF/?id=${studentId}&billNo=${billNo}`,
      );
      if (response.status === 200 && response.data.data) {
        setBillDetails(response.data.data);
        setShowBillModal(true);
      }
    } catch (error) {
      console.error("Error fetching bill details:", error);
      toast.error("Failed to fetch bill details", { position: "top-right" });
    }
  };

  const selectOptions: Option[] = useMemo(
    () =>
      studentAdmissionNo.map((student) => ({
        value: student.admissionNumber,
        label: student.admissionNumber,
      })),
    [studentAdmissionNo],
  );
  const downloadPDF = () => {
    const doc = new jsPDF();
    const title = "Student Fees Report";

    doc.setFontSize(16);
    const pageWidth = doc.internal.pageSize.getWidth();
    const titleWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - titleWidth) / 2;
    doc.text(title, titleX, 10);

    const student = studentFeesList[0];

    autoTable(doc, {
      startY: 20,
      theme: "plain",
      styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.3 },
      head: [["Student Info", "Student Details"]],
      body: [
        ["Name", student.studentName],
        ["Admission Number", student.admissionNumber],
        ["Branch", student.branchName],
        ["Course", student.courseName],
        ["Batch", student.batch],
        ["Phone No", student.phoneNumber],
      ],
    });

    const filteredFeesData = [
      ...studentFeesList,
      ...studentMiscFeesList,
    ].filter((data) => data.amount > 0);

    autoTable(doc, {
      startY: 80,
      theme: "plain",
      styles: { fontSize: 8, lineColor: [0, 0, 0], lineWidth: 0.3 },
      headStyles: { fontSize: 8 },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "left" },
        2: { halign: "left" },
        3: { halign: "left" },
        4: { halign: "right" },
        5: { halign: "right" },
        6: { halign: "right" },
        7: { halign: "left" },
        8: { halign: "right" },
        9: { halign: "right" },
        10: { halign: "right" },
      },
      footStyles: { fontSize: 8, fontStyle: "bold", halign: "right" },
      head: [
        [
          "S.No",
          "Academic Year",
          "Term",
          "Fees Title",
          "Amount",
          "Due Amount",
          "Amount Paid",
          "Balance",
        ],
      ],
      body: filteredFeesData.map(
        (stu, i) =>
          [
            i + 1,
            stu.academicYear,
            stu.academicPeriod + " " + stu.feesType,
            stu.title,
            stu.amount,
            stu.amount - (stu.scAmount ?? 0),
            stu.amountPaid ?? 0,
            stu.amount - ((stu.amountPaid ?? 0) + (stu.scAmount ?? 0)),
          ] as (string | number)[],
      ),
      foot: [
        [
          { content: "Total", colSpan: 4, styles: { halign: "right" } },
          { content: rupeeFormat(totalAmount), styles: { halign: "right" } },
          {
            content: rupeeFormat(totalAmount - totalScAmount),
            styles: { halign: "right" },
          },
          {
            content: rupeeFormat(totalAmountPaid),
            styles: { halign: "right" },
          },
          {
            content: rupeeFormat(netBalance),
            styles: { halign: "right" },
          },
        ],
      ],
    });

    doc.save(`${admissionNo}_bill_details.pdf`);
  };

  const generatePDF = (
    studentFeesList: StudentFeesPayment[],
    copyName: string,
  ) => {
    const MAX_ROWS_PER_PAGE = 15;
    const allParticulars = studentFeesList.filter((field) => field.amount > 0);
    const totalPages = Math.ceil(allParticulars.length / MAX_ROWS_PER_PAGE);
    const student = studentFeesList.length > 0 ? studentFeesList[0] : null;
    const doc = new jsPDF();

    for (let page = 0; page < totalPages; page++) {
      if (page > 0) {
        doc.addPage();
      }

      const startIndex = page * MAX_ROWS_PER_PAGE;
      const endIndex = Math.min(
        startIndex + MAX_ROWS_PER_PAGE,
        allParticulars.length,
      );
      const imgPath = studentFeesList[0]?.photo;
      const title = student?.branchName || "Unknown Branch";

      doc.setFontSize(10);
      doc.setFont("times", "bold");
      doc.text(
        copyName ? `[${copyName}]` : "",
        doc.internal.pageSize.getWidth() - 10,
        10,
        { align: "right" },
      );
      doc.setFont("Arial", "bold");

      doc.setFontSize(11);
      const pageWidth = doc.internal.pageSize.getWidth();
      const titleX = pageWidth / 2;

      doc.text(title, titleX + 5, 14, { align: "center", maxWidth: 80 });
      doc.addImage(imgPath, "JPEG", titleX - 70, 3, 30, 30);

      doc.setFontSize(10);
      let yPos = 25;

      doc.setFont("Arial", "normal");
      // const approvedText = student?.approvedBy ? `(${student?.approvedBy.trimEnd()})` : "";
      // if (approvedText) {
      //     const textWidth1 = doc.getTextWidth(approvedText);
      //     const textX1 = (pageWidth - textWidth1) / 2;
      //     doc.text(approvedText, textX1 + 7, yPos);
      //     yPos += 5;
      // }

      const recognisedText = student?.recognisedBy
        ? `(${student?.recognisedBy.trimEnd()})`
        : "";
      if (recognisedText) {
        const textWidth2 = doc.getTextWidth(recognisedText);
        const textX2 = (pageWidth - textWidth2) / 2;
        doc.text(recognisedText, textX2 + 7, yPos);
        yPos += 5;
      }

      const sponsoredText = student?.sponsoredBy
        ? `(${student?.sponsoredBy.trimEnd()})`
        : "";
      if (sponsoredText) {
        const textWidth3 = doc.getTextWidth(sponsoredText);
        const textX3 = (pageWidth - textWidth3) / 2;
        doc.text(sponsoredText, textX3 + 7, yPos);
        yPos += 5;
      }

      const universityText = student?.affiliatedUniversity
        ? `(${student?.affiliatedUniversity.trimEnd()})`
        : "";
      if (universityText) {
        const textWidth4 = doc.getTextWidth(universityText);
        const textX4 = (pageWidth - textWidth4) / 2;
        doc.text(universityText, textX4 + 7, yPos);
        yPos += 8;
      }

      const placeText = student?.place ? `${student?.place.trimEnd()}` : "";
      if (placeText) {
        const textWidth5 = doc.getTextWidth(placeText);
        const textX5 = (pageWidth - textWidth5) / 2;
        doc.text(placeText, textX5 + 7, yPos);
        yPos += 8;
      }

      doc.line(10, yPos - 2, 90, yPos - 2);
      doc.line(120, yPos - 2, 200, yPos - 2);

      doc.setFontSize(14);
      const textWidth6 = doc.getTextWidth("Fees Receipt");
      const textX6 = (pageWidth - textWidth6) / 2;
      doc.text("Fees Receipt", textX6, yPos);
      yPos += 10;

      const headerRows1: any[] = [
        [
          { content: "Name:", styles: { halign: "left", fontStyle: "bold" } },
          {
            content: student?.studentName
              ? student.studentName.charAt(0).toUpperCase() +
                student.studentName.slice(1)
              : "",
            styles: { halign: "left", cellWidth: 95 },
          },
          {
            content: "Bill No:",
            styles: { halign: "left", fontStyle: "bold" },
          },
          { content: student?.billNo || "", styles: { halign: "left" } },
        ],
        [
          { content: "Class :", styles: { halign: "left", fontStyle: "bold" } },
          {
            content: student?.courseName
              ? student.courseName.charAt(0).toUpperCase() +
                student.courseName.slice(1)
              : "",
            styles: { halign: "left", cellWidth: 95 },
          },
          {
            content: "Date:",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: `${LocalFormatDate(student?.date||"")}`,
            styles: { halign: "left" },
          },
        ],
        [
          {
            content: "Admission No:",
            styles: { halign: "left", fontStyle: "bold" },
          },
          {
            content: student?.admissionNumber || "",
            styles: { halign: "left", cellWidth: 95 },
          },
          { content: "Mode:", styles: { halign: "left", fontStyle: "bold" } },
          {
            content: student?.paymentMode
              ? student.paymentMode.charAt(0).toUpperCase() +
                student.paymentMode.slice(1)
              : "",
            styles: { halign: "left" },
          },
        ],
      ];

      autoTable(doc, {
        startY: yPos,
        theme: "plain",
        styles: { fontSize: 10, lineColor: [255, 255, 255], lineWidth: 0.3 },
        head: [],
        body: headerRows1,
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.3,
      });

      const particularsData = Array.from(
        { length: MAX_ROWS_PER_PAGE },
        (_, index) => {
          const actualIndex = startIndex + index;
          if (actualIndex < endIndex) {
            const field = allParticulars[actualIndex];
            return [
              { content: (actualIndex + 1).toString() },
              {
                content: `${field.academicPeriod} ${field.feesType === "semester" ? "sem" : field.feesType}`,
              },
              field.title,
              { content: `${field.amount.toFixed(2)}` },
            ];
          } else {
            return [{ content: "" }, { content: "" }, "", { content: "" }];
          }
        },
      );

      const pageTotalAmount = allParticulars
        .slice(startIndex, endIndex)
        .reduce((sum, field) => sum + Number(field.amount), 0);

      const footerRows3: any[] = [
        [
          { content: "", styles: { cellWidth: 18 } },
          { content: "", styles: { cellWidth: 20 } },
          { content: "Total", styles: { halign: "right" } },
          {
            content: `Rs. ${pageTotalAmount.toFixed(2)}`,
            styles: { halign: "right" },
          },
        ],
        [
          { content: "", styles: { cellWidth: 18 } },
          { content: "", styles: { cellWidth: 20 } },
          {
            content: `Amount in words: ${amountInWords(pageTotalAmount)} Only`,
            colSpan: 2,
            styles: { halign: "right", fontSize: 10, fontStyle: "italic" },
          },
        ],
      ];

      autoTable(doc, {
        startY: (doc as any).lastAutoTable.finalY,
        theme: "plain",
        styles: {
          fontSize: 10,
          lineColor: [255, 255, 255],
          lineWidth: 0,
        },
        head: [
          [
            {
              content: "S.No",
              styles: {
                halign: "center",
                fontStyle: "bold",
                lineColor: [0, 0, 0],
              },
            },
            {
              content: "Term",
              styles: {
                halign: "center",
                fontStyle: "bold",
                lineColor: [0, 0, 0],
              },
            },
            {
              content: "Particulars",
              styles: {
                halign: "center",
                fontStyle: "bold",
                lineColor: [0, 0, 0],
              },
            },
            {
              content: "Amount",
              styles: {
                halign: "right",
                fontStyle: "bold",
                lineColor: [0, 0, 0],
              },
            },
          ],
        ],
        body: particularsData,
        foot: footerRows3,
        headStyles: {
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
          halign: "center",
          valign: "middle",
          fontSize: 10,
          cellPadding: 5,
          fillColor: [255, 255, 255],
        },
        bodyStyles: {
          fontSize: 10,
          cellPadding: 2,
          minCellHeight: 3,
          valign: "middle",
          lineWidth: 0,
          lineColor: [255, 255, 255],
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 18, lineColor: [0, 0, 0] },
          1: { halign: "center", cellWidth: 20, lineColor: [0, 0, 0] },
          2: { cellWidth: 108.6, halign: "left", lineColor: [0, 0, 0] },
          3: { halign: "right", cellWidth: 35, lineColor: [0, 0, 0] },
        },
        footStyles: {
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
          fontSize: 10,
          fontStyle: "bold",
          cellPadding: 2,
          halign: "right",
          valign: "middle",
        },
        didDrawCell: (data) => {
          doc.setLineWidth(0.3);
          doc.setDrawColor(0, 0, 0);
          doc.line(
            data.cell.x + data.cell.width,
            data.cell.y,
            data.cell.x + data.cell.width,
            data.cell.y + data.cell.height,
          );
          if (data.column.index === 0) {
            doc.line(
              data.cell.x,
              data.cell.y,
              data.cell.x,
              data.cell.y + data.cell.height,
            );
          }
        },
      });

      doc.setFontSize(10);
      // doc.setFont("times", "bold");
      // doc.text(`Amount in words: ${amountInWords(pageTotalAmount)} Only`, 10, (doc as any).lastAutoTable.finalY + 5);
      // doc.setFont("times", "normal");

      doc.line(
        10,
        (doc as any).lastAutoTable.finalY + 8,
        200,
        (doc as any).lastAutoTable.finalY + 8,
      );

      doc.setFont("times", "bold");
      doc.text(
        `Billed By: ${student?.createdBy}`,
        10,
        (doc as any).lastAutoTable.finalY + 16,
      );
      doc.setFont("times", "normal");

      doc.setFontSize(10);
      doc.setFont("times", "italic");
      doc.text(
        "Fees once paid will not be refunded under any circumstances.",
        10,
        (doc as any).lastAutoTable.finalY + 21,
      );
      doc.setFontSize(12);
      doc.setFont("times");
      doc.text(
        "Signature of Receiving Officer",
        150,
        (doc as any).lastAutoTable.finalY + 26,
      );

      doc.setFontSize(8);
      doc.setFont("Arial", "bold");
    }

    const pageCount = (doc as any).internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      doc.setFontSize(10);
      doc.setFont("times", "italic");
      doc.text("This is computer generated bill", 10, pageHeight - 10, {
        align: "left",
      });
      doc.setFont("times", "bold");
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 10, pageHeight - 10, {
        align: "right",
      });
    }

    doc.save(`${student?.billNo}_bill.pdf`);
  };

  const exportPDF = (type = "active") => {
    const doc = new jsPDF();
    const filteredData =
      type === "active"
        ? studentFeesDetails.filter((d) => d.status !== "cancelled")
        : studentFeesDetails.filter((d) => d.status === "cancelled");

    const title =
      type === "active"
        ? `Active Bill Details - Admission No: ${admissionNo}`
        : `Cancelled Bill Details - Admission No: ${admissionNo}`;

    const headers =
      type === "active"
        ? [
            "S.No",
            "Bill.No",
            "Academic Year",
            "Term",
            "Fees Title",
            "Payment Mode",
            "Particulars",
            "Amount",
            "Date",
          ]
        : [
            "S.No",
            "Original Bill.No",
            "Cancelled Bill.No",
            "Fees Title",
            "Amount",
            "Cancellation Date",
          ];

    const body: any[] = filteredData.map((details, index) => {
      if (type === "active") {
        return [
          index + 1,
          details.billNo ?? "-",
          details.academicYear ?? "-",
          `${details.academicPeriod ?? "-"} ${details.feesType ?? "-"}`,
          details.title ?? "-",
          details.paymentMode ?? "-",
          details.particulars ?? "-",
          details.amount ?? 0,
          LocalFormatDate(details.date ?? "-"),
        ];
      } else {
        const originalBillNo = (details?.particulars ?? "").includes("Bill No:")
          ? (details?.particulars ?? "").split("Bill No: ")[1]?.split(" ")[0]
          : "N/A";

        return [
          index + 1,
          originalBillNo,
          details.billNo ?? "-",
          details.title ?? "-",
          { content: `${details.amount ?? 0}`, styles: { halign: "right" } },
          LocalFormatDate(details.date ?? "-"),
        ];
      }
    });

    doc.setFontSize(14);
    doc.text(title, 14, 10);
    doc.setFontSize(10);
    doc.text(
      `Generated on: ${LocalFormatDate(new Date().toLocaleDateString())}`,
      14,
      16,
    );

    autoTable(doc, {
      startY: 22,
      head: [headers],
      body: body,
      theme: "plain",
      styles: {
        lineWidth: 0.1,
        lineColor: 0,
        textColor: 0,
        fontSize: 8,
      },
      headStyles: {
        lineWidth: 0.1,
        lineColor: 0,
        textColor: 0,
        fontStyle: "bold",
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "left" },
        2: { halign: "left" },
        3: { halign: "left" },
        4: { halign: "left" },
        5: { halign: "left" },
        6: { halign: "left" },
        7: { halign: "right" },
        8: { halign: "left" },
      },
    });

    doc.save(`${admissionNo}_${type}_fees_details.pdf`);
  };

  const exportCSV = (type = "active") => {
    const filteredData =
      type === "active"
        ? studentFeesDetails.filter((d) => d.status !== "cancelled")
        : studentFeesDetails.filter((d) => d.status === "cancelled");

    const headers =
      type === "active"
        ? "S.No,Bill.No,Admission No,Academic Year,Term,Fees Title,Payment Mode,Particulars,Amount,Date\n"
        : "S.No,Admission No,Original Bill.No,Cancelled Bill.No,Fees Title,Amount,Cancellation Date\n";

    let csvContent = headers;

    filteredData.forEach((details, index) => {
      if (type === "active") {
        const row = [
          index + 1,
          details.billNo,
          admissionNo,
          details.academicYear,
          `${details.academicPeriod} ${details.feesType}`,
          details.title,
          details.paymentMode ?? "-",
          details.particulars ?? "-",
          details.amount,
          LocalFormatDate(details.date),
        ].join(",");
        csvContent += row + "\n";
      } else {
        const originalBillNo = (details?.particulars ?? "").includes("Bill No:")
          ? (details?.particulars ?? "").split("Bill No: ")[1]?.split(" ")[0]
          : "N/A";

        const row = [
          index + 1,
          admissionNo,
          originalBillNo,
          details.billNo,
          details.title,
          details.amount,
          LocalFormatDate(details.date),
        ].join(",");
        csvContent += row + "\n";
      }
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${admissionNo}_${type}_fees_details.csv`;
    link.click();
  };

  const clearHandler = () => {
    // setRegisterNo('');
    // setAdmissionNo('')
    setAdmissionNo("");
    setFeesAmounts({});
    setStudentFeesList([]);
    setStudentMiscFeesList([]);
    setStudentFeesDetails([]);
    setTitle("");
    setAcademicPeriod("");
    setIsModalOpen(false);
    setId(0);
    setBillNo(0);
    setFeesType("year");
    setAcademicYear("");
    setAmount("");
    setDate("");
    setParticulars("");
    setAmountError("");
    setShowDeleteConfirmation(false);
    setShowDownloadButton(false);
    setSelectedBankAccount("");
    setPaymentMode("cash");
     setDate(new Date().toISOString().split("T")[0]);
  };

  const handleAmountChange = (
    feeTypes: "regular" | "misc",
    studentId: number,
    index: number,
    value: string,
  ) => {
    console.log(feeTypes);
    const parsedValue = parseFloat(value) || 0;
    if (parsedValue < 0) {
      toast.error("Amount cannot be negative", { position: "top-right" });
      return;
    }

    // Determine the correct list to fetch balance
    const feeList =
      feeTypes === "regular" ? studentFeesList : studentMiscFeesList;
    const student = feeList[index];

    if (!student) {
      console.error("Student data is missing at index:", index);
      return;
    }

    const balance =
      student.amount - ((student.amountPaid ?? 0) + (student.scAmount ?? 0));

    if (parsedValue > balance) {
      toast.error("Payment amount cannot exceed the balance", {
        position: "top-right",
      });
      return;
    }

    setFeesAmounts((prev: FeesAmounts) => ({
      ...prev,
      [`${feeTypes}-${studentId}-${index}`]: parsedValue,
    }));
  };

  useEffect(() => {
    const newFeesAmounts: FeesAmounts = {};

    studentFeesList?.forEach((student, index) => {
      const balance =
        student.amount - ((student.amountPaid ?? 0) + (student.scAmount ?? 0));
      if (balance > 0) {
        newFeesAmounts[`regular-${student.studentId}-${index}`] = 0;
      }
    });

    setFeesAmounts((prev) => ({ ...prev, ...newFeesAmounts }));
  }, [studentFeesList]);

  const addHandler = () => {
    let error = false;

    if (paymentMode === "bank" && !selectedBankAccount) {
      toast.error("Please select a bank account", { position: "top-right" });
      return;
    }

    const regularFeesData = studentFeesList?.map((student, index) => ({
      studentId: student.studentId,
      admissionNo: student.admissionNumber,
      academicYear: student.academicYear,
      feesType: student.feesType,
      academicPeriod: student.academicPeriod,
      title: student.title,
      date:date,
      paymentMode: paymentMode,
      particulars: particulars,
      amount: feesAmounts[`regular-${student.studentId}-${index}`] || 0,
      bankAccountNumber: paymentMode === "bank" ? selectedBankAccount : null,
      created_by: authUser.userId,
      status: "active",
    }));

    const miscFeesData = studentMiscFeesList?.map((student, index) => ({
      studentId: student.studentId,
      admissionNo: student.admissionNumber,
      academicYear: student.academicYear,
      feesType: student.feesType,
      academicPeriod: student.academicPeriod,
      title: student.title,
      date:date,
      paymentMode: paymentMode,
      particulars: particulars,
      amount: feesAmounts[`misc-${student.studentId}-${index}`] || 0,
      bankAccountNumber: paymentMode === "bank" ? selectedBankAccount : null,
      created_by: authUser.userId,
      status: "active",
    }));

    const feesData = [...regularFeesData, ...miscFeesData];
    const filteredFeesData = feesData.filter((data) => data.amount > 0);

    if (filteredFeesData.length === 0) {
      toast.error("No fees data to submit. Please enter valid amounts.", {
        position: "top-right",
      });
      return;
    }

    const data = { filteredFeesData };

    setLoading(true);

    axios
      .post(`${apiUrl}/studentFee/stuPaymentByRegNo/`, data)
      .then((response) => {
        setProgress(100);

        setTimeout(() => {
          if (response.data.error) {
            toast.error(response.data.message, { position: "top-right" });
          } else if (response.status === 200) {
            toast.success(response.data.message, { position: "top-right" });

            const billNo = response.data.data[0].billNo;
            const id = response.data.data[0].studentId;

            // PDF generate
            axios
              .get(`${apiUrl}/studentFee/paymentPDF/?id=${id}&billNo=${billNo}`)
              .then((pdfResponse) => {
                if (pdfResponse.status === 200 && pdfResponse.data.data) {
                  if (pdfResponse.data.data.length > 0) {
                    generatePDF(pdfResponse.data.data, "Orginal");
                  }
                }
              })
              .catch((err) => console.error("PDF Error:", err));

            // Refresh data
            fetchFeesDetails(admissionNo);
            fetchStudentFeesList(admissionNo || "0");
            fetchStuMiscFeesList(admissionNo || "0");
            setFeesAmounts({});
            setPaymentMode("cash");
            setSelectedBankAccount("");
            setDate(new Date().toISOString().split("T")[0]);
          }

          setLoading(false);
          setProgress(0);
        }, 600);
      })
      .catch((err) => {
        setTimeout(() => {
          toast.error(err.response?.data?.message || "Something went wrong", {
            position: "top-right",
          });
          console.error("Error:", err.response?.data?.message);

          setLoading(false);
          setProgress(0);
        }, 600);
      });
  };

  const openDeleteConfirmation = () => {
    setShowDeleteConfirmation(true);
  };

  const closeDeleteConfirmation = () => {
    setShowDeleteConfirmation(false);
  };

  const deleteHandler = (id: number, title: string) => {
    setId(id);
    setTitle(title);
    openDeleteConfirmation();
  };

  const confirmDeleteHandler = () => {
    axios
      .delete(`${apiUrl}/studentFee/?id=${ids}`)
      .then((response) => {
        toast.success(response.data.message, { position: "top-right" });
        closeDeleteConfirmation();
        fetchFeesDetails(admissionNo);
        fetchStudentFeesList(admissionNo ? admissionNo : "0");
      })
      .catch((error) => {
        toast.error(error.response.data.message, { position: "top-right" });
      });
  };

  const totalAmount = [...studentFeesList, ...studentMiscFeesList].reduce(
    (acc, student) => acc + (student.amount ?? 0),
    0,
  );
  const totalScAmount = [...studentFeesList, ...studentMiscFeesList].reduce(
    (acc, student) => acc + (student.scAmount ?? 0),
    0,
  );
  const totalAmountPaid = [...studentFeesList, ...studentMiscFeesList].reduce(
    (acc, student) => acc + (student.amountPaid ?? 0),
    0,
  );

  const netBalance = totalAmount - totalAmountPaid - totalScAmount;

  const totalPay = Object.values(feesAmounts).reduce(
    (acc, curr) => acc + curr,
    0,
  );

  const totalBillAmount = billDetails
    .filter((field) => field.amount > 0)
    .reduce((sum, field) => sum + Number(field.amount), 0);

  const formattedTotal = rupeeFormat(totalBillAmount);

  return (
    <Main>
      <PageContainer title="Student Billing">
        <div className="d-flex justify-content-center align-items-center my-4 mt-0">
          {/* <div style={{ width: "300px" }}>
                        <Select
                            // className="form-control"
                            value={selectOptions?.find(option => option.value === admissionNo) || null}
                            onChange={(selectedOption) => selectedOption && setAdmissionNo(selectedOption.value)}
                            options={selectOptions}
                            placeholder="Select Admission Number"
                            isSearchable
                        />
                        
                    </div> */}

          <StudentAdmissionDropdown
            selectOptions={selectOptions}
            admissionNo={admissionNo}
            setAdmissionNo={setAdmissionNo}
          />
          <Button
            variant="primary"
            style={{ marginLeft: "5px", backgroundColor: "#10296C" }}
            onClick={() => {
              fetchStudentFeesList(admissionNo || "");
              fetchStuMiscFeesList(admissionNo || "");
              fetchFeesDetails(admissionNo || "");
            }}
          >
            Go
          </Button>
          <Button
            variant="secondary"
            style={{ marginLeft: "5px" }}
            onClick={clearHandler}
          >
            Clear
          </Button>
        </div>

        {studentFeesList.length > 0 ? (
          <div>
            <div
              className="card m-2 shadow-sm"
              style={{
                borderLeft: "5px solid #4e73df",
                borderRadius: "0.35rem",
              }}
            >
              <div className="row p-3">
                <div className="col-sm-12 col-md-12 col-lg-4 d-flex justify-content-center align-items-center">
                  <img
                    src={apiUrl + "/" + studentFeesList[0]?.photoUrl}
                    alt={studentFeesList[0]?.studentName || "Student Image"}
                    className="student-thumbnail img-thumbnail shadow"
                    style={{
                      objectFit: "cover",
                      height: "160px",
                      width: "160px",
                      border: "3px solid #f8f9fc",
                      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                      borderRadius: "0.25rem",
                    }}
                  />
                </div>
                <div className="col-sm-12 col-md-12 col-lg-8">
                  <div
                    className="p-3"
                    style={{
                      backgroundColor: "#f8f9fc",
                      borderRadius: "0.25rem",
                    }}
                  >
                    <h5
                      className="mb-3 text-primary"
                      style={{
                        borderBottom: "1px solid #e3e6f0",
                        paddingBottom: "0.5rem",
                      }}
                    >
                      <i className="fas fa-user-graduate mr-2"></i>
                      Student Details
                    </h5>
                    <div className="row">
                      <div className="col-md-6">
                        <h6 className="text-dark mb-3">
                          <span
                            className="font-weight-bold"
                            style={{ color: "#4e73df" }}
                          >
                            Name:{" "}
                          </span>
                          <span style={{ color: "#8E1616" }}>
                            {studentFeesList[0]?.studentName}
                          </span>
                        </h6>
                        <h6 className="text-dark mb-2">
                          <span
                            className="font-weight-bold"
                            style={{ color: "#4e73df" }}
                          >
                            Register No:{" "}
                          </span>
                          <span style={{ color: "#C62300" }}>
                            {studentFeesList[0]?.registerNumber}
                          </span>
                        </h6>
                        <h6 className="text-dark mb-2">
                          <span
                            className="font-weight-bold"
                            style={{ color: "#4e73df" }}
                          >
                            Admission No:{" "}
                          </span>
                          <span style={{ color: "#C62300" }}>
                            {studentFeesList[0]?.admissionNumber}
                          </span>
                        </h6>
                      </div>
                      <div className="col-md-6">
                        <h6 className="text-dark mb-2">
                          <span
                            className="font-weight-bold"
                            style={{ color: "#4e73df" }}
                          >
                            Branch:{" "}
                          </span>
                          <span className="text-gray-800">
                            {studentFeesList[0]?.branchName}
                          </span>
                        </h6>
                        <h6 className="text-dark mb-2">
                          <span
                            className="font-weight-bold"
                            style={{ color: "#4e73df" }}
                          >
                            Course:{" "}
                          </span>
                          <span className="text-gray-800">
                            {studentFeesList[0]?.courseName}
                          </span>
                        </h6>
                        <h6 className="text-dark mb-2">
                          <span
                            className="font-weight-bold"
                            style={{ color: "#4e73df" }}
                          >
                            Batch:{" "}
                          </span>
                          <span className="text-gray-800">
                            {studentFeesList[0]?.batch}
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="student-fees-container">
              <Card title="STUDENT FEES LIST">
                {studentFeesList?.length > 0 ||
                studentMiscFeesList?.length > 0 ? (
                  <>
                    <table className="table table-hover text-center">
                      <thead
                        style={{ backgroundColor: "#10296C", color: "#ffffff" }}
                      >
                        <tr>
                          <th>S.No</th>
                          <th>Academic Year</th>
                          <th>Term</th>
                          <th>Fees Title</th>
                          <th>Amount</th>
                          <th>Concession</th>
                          <th>Due Amount</th>
                          <th>Due Date</th>
                          <th>Amount Paid</th>
                          <th>Balance</th>
                          <th>Pay</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...studentFeesList, ...studentMiscFeesList]?.map(
                          (student, index) => {
                            const balance =
                              student.amount -
                              ((student.amountPaid ?? 0) +
                                (student.scAmount ?? 0));
                            const isMiscFee =
                              studentMiscFeesList.includes(student); // Identify if it's a misc fee
                            const originalIndex = isMiscFee
                              ? studentMiscFeesList.indexOf(student)
                              : studentFeesList.indexOf(student); // Get the correct index

                            return (
                              <tr key={student.studentId || index}>
                                <td>{index + 1}</td>
                                <td>{student.academicYear}</td>
                                <td>
                                  {student.academicPeriod} {student.feesType}
                                </td>
                                <td>{student.title}</td>
                                <td style={{ textAlign: "right" }}>
                                  {student.amount}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {student.scAmount ?? 0}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {student.amount - (student.scAmount ?? 0)}
                                </td>
                                <td>
                                  {student.lastDate
                                    ? LocalFormatDate(student.lastDate)
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {student.amountPaid ?? 0}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  {balance}
                                </td>
                                <td>
                                  {isMiscFee ? (
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Misc Fee Amount"
                                      // max={balance}
                                      value={
                                        feesAmounts[
                                          `misc-${student.studentId}-${originalIndex}`
                                        ] || ""
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                          handleAmountChange(
                                            "misc",
                                            student.studentId,
                                            originalIndex,
                                            e.target.value,
                                          );
                                        }
                                      }}
                                    />
                                  ) : (
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Regular Fee Amount"
                                      // max={balance}
                                      value={
                                        feesAmounts[
                                          `regular-${student.studentId}-${originalIndex}`
                                        ] || ""
                                      }
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) {
                                          handleAmountChange(
                                            "regular",
                                            student.studentId,
                                            originalIndex,
                                            e.target.value,
                                          );
                                        }
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          },
                        )}
                        <tr
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#255F38",
                            color: "#ffffff",
                          }}
                        >
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>Total</td>
                          <td style={{ textAlign: "right" }}>
                            {rupeeFormat(totalAmount)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {rupeeFormat(totalScAmount)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {rupeeFormat(totalAmount - totalScAmount)}
                          </td>
                          <td></td>
                          <td style={{ textAlign: "right" }}>
                            {rupeeFormat(totalAmountPaid)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {rupeeFormat(netBalance)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            <h6 style={{ fontSize: "18px" }}>
                              <span
                                className="ml-2"
                                style={{ fontWeight: "bold" }}
                              >
                                {rupeeFormat(totalPay)}
                              </span>
                            </h6>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="row mt-3">
                      <div className="col-6">
                        <label className="mr-2">Payment Mode:</label>
                        <label className="mr-2">
                          <input
                            type="radio"
                            name="paymentMode"
                            value="cash"
                            checked={paymentMode === "cash"}
                            onChange={() => setPaymentMode("cash")}
                          />{" "}
                          Cash
                        </label>
                        <label className="ml-2">
                          <input
                            type="radio"
                            name="paymentMode"
                            value="bank"
                            checked={paymentMode === "bank"}
                            onChange={() => setPaymentMode("bank")}
                          />{" "}
                          Bank
                        </label>
                      </div>
                      <div className="col-5 ms-5">
                        <label className="mr-2">Date</label>
                        <input
                        type="date"
                        name="date"
                        value={date}
                        onChange={(e)=>setDate(e.target.value)}/>
                      </div>

                      {paymentMode === "bank" && (
                        <div className="col-12 mt-2">
                          <label className="mr-2">Select Bank Account:</label>
                          <select
                            className="form-control"
                            style={{ width: "50%" }}
                            value={selectedBankAccount}
                            onChange={(e) =>
                              setSelectedBankAccount(e.target.value)
                            }
                          >
                            <option value="">Select Bank</option>

                            {bankAccounts
                              .filter(
                                (al) =>
                                  al.groupName?.toLowerCase() === "main" &&
                                  al.accountName
                                    ?.toLowerCase()
                                    .includes("bank"),
                              )
                              .map((acc) => (
                                <option
                                  key={acc.accountNumber}
                                  value={acc.accountNumber}
                                >
                                  {acc.accountName}
                                </option>
                              ))}
                          </select>
                        </div>
                      )}
                      <div className="col-12">
                        <label className="mr-2">Particulars:</label>
                        <textarea
                          className="form-control"
                          placeholder="Enter Particulars"
                          value={particulars}
                          onChange={(e) => setParticulars(e.target.value)}
                          style={{ width: "50%" }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <Button
                        className="btn btn-sm m-2"
                        variant="primary"
                        onClick={addHandler}
                        disabled={loading}
                        style={{
                          width: "100px",
                          backgroundColor: loading ? "#6c757d" : "#10296C",
                          cursor: loading ? "not-allowed" : "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                          position: "relative",
                          overflow: "hidden",
                          minHeight: "38px",
                        }}
                      >
                        {/* Button Content */}
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                              style={{
                                width: "14px",
                                height: "14px",
                                borderWidth: "2px",
                              }}
                            />
                            <span style={{ fontSize: "12px" }}>
                              {progress}%
                            </span>
                          </>
                        ) : (
                          "Pay"
                        )}

                        {loading && (
                          <div
                            style={{
                              position: "absolute",
                              bottom: 0,
                              left: 0,
                              height: "3px",
                              width: `${progress}%`,
                              backgroundColor: "#28a745",
                              transition: "width 0.3s ease-in-out",
                            }}
                          />
                        )}
                      </Button>

                      {studentFeesList?.length > 0 && (
                        <button
                          className="btn btn-success btn-sm m-2 d-flex align-items-center"
                          onClick={downloadPDF}
                          style={{ width: "7%", fontSize: "14px" }}
                          disabled={loading}
                        >
                          <Feather.Download className="mr-1" size={16} /> PDF
                        </button>
                      )}
                    </div>
                  </>
                ) : (
                  <div className="text-center p-4">
                    <h5>No student fees data available.</h5>
                  </div>
                )}
              </Card>

              <div className="fees-details-card">
                <Card title="Bill Particulars">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "10px",
                    }}
                  >
                    <button
                      onClick={() => exportPDF("active")}
                      style={{
                        padding: "5px 10px",
                        marginRight: "10px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <Feather.Download className="mr-1" size={16} /> PDF
                    </button>
                    <button
                      onClick={() => exportCSV("active")}
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#28a745",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <Feather.Download className="mr-1" size={16} /> CSV
                    </button>
                  </div>
                  <table className="table text-center">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Bill.No</th>
                        <th>Academic Year</th>
                        <th>Term</th>
                        <th>Fees Title</th>
                        <th>Amount</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentFeesDetails?.filter(
                        (d) => d.status !== "cancelled",
                      ).length > 0 ? (
                        studentFeesDetails
                          ?.filter((d) => d.status !== "cancelled")
                          ?.map((details, index) => (
                            <tr key={`active-${index}`}>
                              <td>{index + 1}</td>
                              <td>
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleBillClick(
                                      details.billNo,
                                      details.studentId,
                                    );
                                  }}
                                  style={{
                                    color: "#007bff",
                                    textDecoration: "none",
                                  }}
                                >
                                  {details.billNo}
                                </a>
                              </td>
                              <td>{details.academicYear}</td>
                              <td>
                                {details.academicPeriod} {details.feesType}
                              </td>
                              <td>{details.title}</td>
                              <td>{details.amount}</td>
                              <td>{LocalFormatDate(details.date)}</td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="text-center text-muted">
                            No active fees found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Card>
                <Card title="Cancelled Particulars">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "10px",
                    }}
                  >
                    <button
                      onClick={() => exportPDF("cancelled")}
                      style={{
                        padding: "5px 10px",
                        marginRight: "10px",
                        backgroundColor: "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <Feather.Download className="mr-1" size={16} /> PDF
                    </button>
                    <button
                      onClick={() => exportCSV("cancelled")}
                      style={{
                        padding: "5px 10px",
                        backgroundColor: "#28a745",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <Feather.Download className="mr-1" size={16} /> CSV
                    </button>
                  </div>
                  <table className="table text-center">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Original Bill.No</th>
                        <th>Cancelled Bill.No</th>
                        <th>Fees Title</th>
                        <th>Amount</th>
                        <th>Cancellation Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {studentFeesDetails?.filter(
                        (d) => d.status === "cancelled",
                      ).length > 0 ? (
                        studentFeesDetails
                          ?.filter((d) => d.status === "cancelled")
                          ?.map((details, index) => {
                            const originalBillNo = (
                              details?.particulars ?? ""
                            ).includes("Bill No:")
                              ? (details?.particulars ?? "")
                                  .split("Bill No: ")[1]
                                  ?.split(" ")[0]
                              : "N/A";

                            return (
                              <tr key={`cancelled-${index}`}>
                                <td>{index + 1}</td>
                                <td>{originalBillNo}</td>
                                <td>{details.billNo}</td>
                                <td>{details.title}</td>
                                <td className="text-danger">
                                  {details.amount}
                                </td>
                                <td>{LocalFormatDate(details.date)}</td>
                              </tr>
                            );
                          })
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center text-muted">
                            No cancelled fees found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Card>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="m-2 p-3 text-center text-muted"
            style={{ height: "500px" }}
          >
            No student data available
          </div>
        )}

        {/* Bill Details Modal */}
        <Modal
          show={showBillModal}
          onHide={() => setShowBillModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Bill Details - {selectedBill?.billNo}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {billDetails.length > 0 && (
              <div>
                <div className="row mb-3">
                  <div className="col-md-7">
                    <p>
                      <strong>Name:</strong> {billDetails[0].studentName}
                    </p>
                    <p>
                      <strong>Register No:</strong>{" "}
                      {billDetails[0].registerNumber}
                    </p>
                    <p>
                      <strong>Admission No:</strong>{" "}
                      {billDetails[0].admissionNumber}
                    </p>
                    <p>
                      <strong>Course:</strong> {billDetails[0].courseName}
                    </p>
                  </div>
                  <div className="col-md-5">
                    <p>
                      <strong>Bill No:</strong> {billDetails[0].billNo}
                    </p>
                    <p>
                      <strong>Date & Time:</strong>{" "}
                      {LocalFormatDate(billDetails[0].date)}{" "}
                      {billDetails[0].time}
                    </p>
                    <p>
                      <strong>Mode:</strong>{" "}
                      {billDetails[0].paymentMode
                        ? billDetails[0].paymentMode.charAt(0).toUpperCase() +
                          billDetails[0].paymentMode.slice(1)
                        : ""}
                    </p>
                  </div>
                </div>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="text-center">Particulars</th>
                      <th className="text-right">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {billDetails
                      .filter((field) => field.amount > 0)
                      .map((field, index) => (
                        <tr key={index}>
                          <td>{field.title}</td>
                          <td className="text-right">
                            {rupeeFormat(field.amount)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <th className="text-right">Total</th>
                      <th className="text-right">{formattedTotal}</th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => {
                if (billDetails.length > 0) {
                  generatePDF(billDetails, "Duplicate Copy");
                }
              }}
            >
              <Feather.Download className="mr-1" size={16} /> Download Receipt
            </Button>
            <Button
              variant="success"
              onClick={() => {
                if (studentFeesList.length > 0) {
                  downloadPDF();
                }
              }}
            >
              <Feather.Download className="mr-1" size={16} /> Download Full
              Report
            </Button>
            <Button variant="secondary" onClick={() => setShowBillModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Deletion Confirmation Modal */}
        <Modal
          show={showDeleteConfirmation}
          onHide={closeDeleteConfirmation}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this fee record?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeDeleteConfirmation}>
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmDeleteHandler}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </PageContainer>
      <ToastContainer />
    </Main>
  );
};

export default StudentFeesByRegisterNo;
